<template>
  <code :class="['code-component', { '-plain': insideCodeBlock }]"><slot /></code>
</template>

<script setup>
import { inject } from 'vue';

defineOptions({ inheritAttrs: false });

const insideCodeBlock = inject('insideCodeBlock', false);
</script>

<style scoped lang="scss" type="text/scss">
  .code-component {
    padding: .1em .25em;
    font-size: .875em;
    line-height: 1.3;
    background-color: map_get($grey, 'lighten-8');
    border: 1px solid $border-color;
    border-radius: $border-radius-sm;
    box-decoration-break: clone;

    &.-plain {
      padding: 0;
      font-size: 1em;
      background-color: transparent;
      border: none;
    }
  }
</style>
